import { useRef } from "react";
import { motion, useScroll, useTransform, useMotionValue, useSpring } from "framer-motion";

export const HeroMark = () => {
  const ref = useRef(null);
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 600], [0, 90]);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-10, 10]), { stiffness: 60, damping: 18 });
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [8, -8]), { stiffness: 60, damping: 18 });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => { mx.set(0); my.set(0); };

  return (
    <motion.div ref={ref} style={{ y }} onMouseMove={onMove} onMouseLeave={onLeave}
      className="relative mx-auto aspect-square w-full max-w-[520px] [perspective:1200px]" data-testid="hero-mark">
      <motion.div
        initial={false}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2.2, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-[-12%] rounded-full bg-[radial-gradient(circle,rgba(212,166,74,0.38)_0%,rgba(212,166,74,0.10)_40%,transparent_68%)]"
      />
      <svg viewBox="0 0 200 200" className="spin-slow absolute inset-[-4%] h-[108%] w-[108%]" aria-hidden="true">
        <circle cx="100" cy="100" r="97" fill="none" stroke="#a8792a" strokeOpacity="0.45" strokeWidth="0.4" strokeDasharray="1 5" />
        {[0, 72, 144, 216, 288].map((a) => (
          <circle key={a} cx={100 + 97 * Math.sin((a * Math.PI) / 180)} cy={100 - 97 * Math.cos((a * Math.PI) / 180)} r="1.6" fill="#a8792a" />
        ))}
      </svg>
      <motion.div style={{ rotateX, rotateY }} className="absolute inset-[6%] [transform-style:preserve-3d]">
        <motion.img
          src="/panchmaya-mark.webp"
          srcSet="/panchmaya-mark-320.webp 320w, /panchmaya-mark-640.webp 640w, /panchmaya-mark.webp 892w"
          sizes="(min-width: 1024px) 430px, (min-width: 640px) 335px, 60vw"
          width="892"
          height="892"
          fetchPriority="high"
          alt="Panchmaya mark: five coloured petals around a golden centre, held in a circle that moves from dark to light"
          initial={false}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          transition={{ duration: 2, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="h-full w-full rounded-full shadow-[0_40px_90px_-30px_rgba(34,30,27,0.45)]"
        />
      </motion.div>
    </motion.div>
  );
};
